import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware, { END } from 'redux-saga';
import * as storage from 'redux-storage';
import createEngine from 'redux-storage-engine-localstorage';
import reducers     from './reducers/index';

export default function create() {
  const reducer = storage.reducer(reducers);
  const engine = createEngine('app-name'); // todo
  const middleware = storage.createMiddleware(
    engine,
  );
  const sagaMiddleware = createSagaMiddleware();
  const createStoreWithMiddleware = applyMiddleware(sagaMiddleware, middleware)(createStore);
  const defaultState = {};
  const enhancers = compose(window.devToolsExtension ? window.devToolsExtension() : f => f);
  const store = createStoreWithMiddleware(reducer, defaultState, enhancers);
  const load = storage.createLoader(engine);
  load(store);

  store.runSaga = sagaMiddleware.run;
  store.close = () => store.dispatch(END);

  return store;
}



// WEBPACK FOOTER //
// ./src/redux/create.js